module.exports = __webpack_public_path__ + "img/toCV3RectangleWenLiGray.8ddc4aa1.png";